import { h, Fragment } from 'preact';
import { useKitProduct } from './kit/product-context';
import { useProduct } from './product-context';
import ProductGallery from './product-gallery';
import ProductInfo from './product-info';
import ProductSizeGuide from './product-size-guide';
import './product.css';

const Product = () => {
  const { allProducts, isKit, imageLayout } = useProduct();
  const kit = useKitProduct();

  if (!allProducts) return;
  if (isKit && !kit) return;

  // Slider layout: contained with sticky gallery
  if (imageLayout === 'slider') {
    return (
      <div className="bg-white relative">
        <div className="max-w-[1440px] mx-auto lg:px-20 lg:py-8">
          <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_500px] lg:gap-6">
            {/* Gallery - Sticky on desktop */}
            <div className="lg:sticky lg:top-8 lg:self-start lg:h-[calc(100vh-64px)] lg:overflow-hidden">
              <ProductGallery />
            </div>
            {/* Product Info - Scrollable */}
            <div>
              <ProductInfo />
            </div>
          </div>
        </div>
        <ProductSizeGuide />
      </div>
    );
  }

  // Grid layout: original full-width layout
  return (
    <div className="grid grid-cols-1 lg:grid-cols-desktopPDP bg-white relative">
      <ProductGallery />
      <ProductInfo />
      <ProductSizeGuide />
    </div>
  );
};

export default Product;
